const initialState = [];
export const notificationsChannelMapList = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_NOTIFICATIONS_CHANNEL_MAP_LIST':
      return action.payload;
    default:
      return state;
  }
};
